import { Modal } from "@mui/material";
import { CommonBatchBrandForm } from "../../components/brand-batch/brand-batch-form";
import ModalBox from "../../components/common/modal";

export const BrandCreate: React.FC<{
  onClose: () => void;
}> = ({ onClose }) => {
  return (
    <Modal open={true} onClose={onClose} aria-labelledby="brand-modal">
      <ModalBox title="Create New Brand">
        <CommonBatchBrandForm onClose={onClose} type="brand" />
      </ModalBox>
    </Modal>
  );
};
